import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class NightimeExperience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      searched_type: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      aircraft_models: [],
      shore: [],
      duties: [],
      receits_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            bases_select: responseJson.data.bases_select,
            flight_types_select: responseJson.data.flight_types_select,
            clients_select: responseJson.data.clients_select,
            receits_select: responseJson.data.receits_select,
            staffs_select: responseJson.data.staffs_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            duties_select: responseJson.data.duties_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      staffs: this.state.staffs,
      aircraft_models: this.state.aircraft_models,
      shore: this.state.shore,
      flight_type_id: this.state.flight_type_id,
      duties: this.state.duties,
      type: this.state.type,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pesquisa/experiencia/noturna', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data, searched_type: self.state.type, searched: 1});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    var columns = null

    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.Tripulantes}:</label>
            <Select
              className=""
              name="staffs"
              value={this.state.staffs}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'staffs')}
              options={this.state.staffs_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.Frotas}:</label>
            <Select
              className=""
              name="aircraft_models"
              value={this.state.aircraft_models}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'aircraft_models')}
              options={this.state.aircraft_models_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.FuncaoDeBordo}:</label>
            <Select
              className=""
              name="duties"
              value={this.state.duties}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'duties')}
              options={this.state.duties_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.Shore}:</label>
            <Select
              className=""
              name="shore"
              value={this.state.shore}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'shore')}
              options={[
                {value: 'On-Shore', label: this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.opcoesShore.OnShore},
                {value: 'Off-Shore', label: this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.opcoesShore.OffShore},
              ]}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.TipoDePesquisa}:</label>
            <Select
              className=""
              name="type"
              value={this.state.type}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'type')}
              options={[
                {value: 'totals', label: this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.opcoesTiposDePesquisa.Totais},
                {value: 'by_flight', label: this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.opcoesTiposDePesquisa.PorVoo},
              ]}
              required
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.formulario.TipoDeVoo}:</label>
            <Select
              className=""
              name="flight_type_id"
              value={this.state.flight_type_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'flight_type_id')}
              options={this.state.flight_types_select}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      {self.state.searched === 1 &&
          <div>
            <hr/>
            {self.state.searched_type === 'totals' &&
              <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
                <TableHeaderColumn dataField={'id'} isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
                <TableHeaderColumn dataField={'inscription'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaTotais.Matricula}</TableHeaderColumn>
                <TableHeaderColumn dataField={'name'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaTotais.Nome}</TableHeaderColumn>
                <TableHeaderColumn dataField={'daytime_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaTotais.PousosDiurnos}</TableHeaderColumn>
                <TableHeaderColumn dataField={'nighttime_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaTotais.PousosNoturnos}</TableHeaderColumn>
                <TableHeaderColumn dataField={'nighttime_hours'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaTotais.HorasNoturnas}</TableHeaderColumn>
                <TableHeaderColumn dataField={'total_hours'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaTotais.HorasTotais}</TableHeaderColumn>
              </BootstrapTable>
            }
            {self.state.searched_type === 'by_flight' &&
              <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
                <TableHeaderColumn dataField={'id'} isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
                <TableHeaderColumn dataField={'inscription'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Matricula}</TableHeaderColumn>
                <TableHeaderColumn dataField={'name'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Nome}</TableHeaderColumn>
                <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Data}</TableHeaderColumn>
                <TableHeaderColumn dataField={'flight_report'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Relatorio}</TableHeaderColumn>
                <TableHeaderColumn dataField={'flight_report_leg'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Trecho}</TableHeaderColumn>
                <TableHeaderColumn dataField={'aircraft_model'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Frota}</TableHeaderColumn>
                <TableHeaderColumn dataField={'duty'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.FuncaoDeBordo}</TableHeaderColumn>
                <TableHeaderColumn dataField={'location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.Localidade}</TableHeaderColumn>
                <TableHeaderColumn dataField={'daytime_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.PousosDiurnos}</TableHeaderColumn>
                <TableHeaderColumn dataField={'nighttime_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.PousosNoturnos}</TableHeaderColumn>
                <TableHeaderColumn dataField={'nighttime_hours'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.HorasNoturnas}</TableHeaderColumn>
                <TableHeaderColumn dataField={'total_hours'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleDeExperienciaNoturna.tabelaPorVoo.HorasTotais}</TableHeaderColumn>
              </BootstrapTable>
            }
          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default NightimeExperience;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/NightimeExperience.js